import { render, staticRenderFns } from "./VCustomerForm.vue?vue&type=template&id=008fe5de&"
import script from "./VCustomerForm.vue?vue&type=script&lang=js&"
export * from "./VCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports